export default{
    txt_ganbu:'幹部',
    txt_beiz: '補充診斷',
    txt_jcsj: '檢測時間',
    txt_jcsj1: '檢測時間',
    txt_cphm: '車牌號碼',
    txt_cphm1: '車牌號碼',
    txt_fwmd: '服務門店',
    txt_jcjg: '檢測結果',
    txt_msqk: '磨損情况',
    txt_jygh: '建議更換',
    txt_zysh: '注意損耗',
    txt_zcsy: '正常使用',
    txt_zc: '正常',
    txt_cz: '重置',
    txt_qd: '確定',
    txt_jcjgd: '檢測結果',
    txt_msqkd: '磨損情况',
    txt_sldwd: '四輪定位',
    txt_jyghd: '建議更換',
    txt_zysh: '注意損耗',
    txt_zcsyd: '正常使用',
    txt_xdwd: '需定位',
    txt_xzyd: '需注意',
    txt_zcd: '正常',
    txt_mddz: '門店地址',
    txt_jcsb: '檢測設備',
    txt_ddmd: '到店目的',
    txt_lic: '里程',
    txt_chex: '車型',
    txt_jcjyi: '檢測建議',
    txt_ysbs: '顏色標識',
    txt_ztms: '整體磨損',
    txt_hwms: '偏磨狀態',
    txt_dqscjltx: '當前刹車距離提醒',
    txt_hwmsjh: '花紋磨損均勻',
    txt_zqlun: '左前輪',
    txt_zhlun: '左後輪',
    txt_yqlun: '右前輪',
    txt_yhlun: '右後輪',
    txt_pingjunzhi: '平均值:',
    txt_guige: '規格',
    txt_gongli: '公里',
    txt_ltwjc: '輪胎未檢測',
    txt_pinpai: '品牌',
    txt_ltws: '輪胎外觀',
    txt_sewmts: '掃描二維碼\n查看報告',
    txt_taici: '台次',
    txt_jianyi: '建議:',
    txt_jianyineirong: '輪胎存在偏磨情况，建議做進一步檢查',
    txt_jianyineirongzc: '正常',
    txt_bgtixing: '提醒:',
    txt_bgtuxubfnr: '根據當前輪胎磨損情况，導致刹車距離新增{0}%（預估值）',
    txt_waishang: '外傷',
    txt_laohua: '老化',
    txt_gubao: '鼓包',
    txt_xichemeirong: '洗車美容',
    txt_weixiubaoyang: '維修保養',
    txt_guenghuanluntai: '更換輪胎',
    txt_scsltjcy: '掌上型輪胎檢測儀',
    txt_lf_outworn: '左前胎外側比內側磨損嚴重',
    txt_lf_innerworn: '左前胎內側比外側磨損嚴重',
    txt_lf_bothsideworn: '左前胎兩側比中間磨損嚴重',
    txt_lf_centreworn: '左前胎中間比兩側磨損嚴重',
    txt_lb_outworn: '左後胎外側比內側磨損嚴重',       
    txt_lb_innerworn: '左後胎內側比外側磨損嚴重',        
    txt_lb_bothsideworn: '左後胎兩側比中間磨損嚴重',        
    txt_lb_centreworn: '左後胎中間比兩側磨損嚴重',        
    txt_rb_outworn: '右後胎外側比內側磨損嚴重',         
    txt_rb_innerworn: '右後胎內側比外側磨損嚴重',        
    txt_rb_bothsideworn: '右後胎兩側比中間磨損嚴重',         
    txt_rb_centreworn: '右後胎中間比兩側磨損嚴重',        
    txt_rf_outworn: '右前胎外側比內側磨損嚴重',         
    txt_rf_innerworn: '右前胎內側比外側磨損嚴重',        
    txt_rf_bothsideworn: '右前胎兩側比中間磨損嚴重',       
    txt_rf_centreworn: '右前胎中間比兩側磨損嚴重',         
    txt_tire_need_replace:'有輪胎磨損需要立即更換',            
    txt_alignment_chassis: '建議進一步進行四輪定位或底盤檢測',              
    txt_do_further_check: '請進一步檢查',                    
    txt_uneven_check: '輪胎磨損异常，建議檢查四輪定位及底盤件',       
    txt_tire_rotation: '建議輪胎換位',           
    txt_wear_normal: '輪胎磨損正常',   
    'txt_wear_normal;': '輪胎磨損正常',                    
    txt_tire: '輪胎',
    txt_gelie:'割裂',
    txt_diaokuai:'掉塊',
    txt_chaungci:'穿刺',
    txt_cashang:'擦傷',
    txt_yichang:'异常',
    txt_qjybjcltazqk:'請進一步檢查輪胎安裝情况',
    txt_wear_overall:'整體磨損', 
    txt_pattern_wear:'异常磨損', 
    txt_tire_age:'輪胎年限',   
    txt_tire_appearance:'輪胎外觀',
    txt_tire_age_5:'輪胎有效期已超過5年，建議更換輪胎',
    txt_tire_age_3:'輪胎有效期已超過3年，請定期進行檢查',
    txt_tire_age_8:'輪胎有效期已超過8年，建議更換輪胎',
    txt_tire_age_6:'輪胎有效期已超過6年，請定期進行檢查',
    txt_tire_age_ok:'輪胎年限良好',
    txt_tire_trauma_check:'輪胎面有外傷，建議做進一步檢查', 
    txt_install_abnormal_check:'輪胎裝反，建議做進一步檢查',
    txt_tire_appearance_ok:'輪胎外觀良好',
    txt_ltlcgstm:'根據當前輪胎磨損情况，輪胎續航里程為{0}km（預估值)',
    'txt_tire_need_replace;':'輪胎嚴重磨損，建議更換輪胎',
    'txt_uneven_check;':'輪胎磨損异常，建議檢查四輪定位及底盤件',
    txt_tire_rotation: '建議輪胎換位', 
    'txt_tire_age_ok': '輪胎年限良好',
    'txt_wear_uniform;': '單個輪胎磨損較均勻',    
    txt_wear_uniform: '单个轮胎磨损较均匀',    
    'txt_tire_boundary;': '單個輪胎磨損較均勻',     
    txt_tire_boundary: '有輪胎磨損已處邊界狀態',  
    txt_plcl:'批量處理',
    txt_qbxz:'全選',
    txt_scjcjg:'上次檢測結果',
    txt_ltxhlcgs:'輪胎續航里程估算',
    txt_ltazhuang:'輪胎安裝:',
    txt_dqltlctx:'當前輪胎已到達極限，請立即更換輪胎',
    txt_dottx:'輪胎使用年限估算',
    txt_danweinian:'(組織：年)',
    txt_danweikm:'(組織:km)',
    txt_myhqdsj:'沒有到獲取DOT時間',
    txt_dotjstx:'輪胎剩餘使用時間約為{0}天',
    txt_dotjstx2:'輪胎使用年限已超過5年，請立即更換',
    txt_dotsjztx:'(DOT:輪胎製造日期)',
    'txt_tire_age_ok;': '輪胎年限良好',
    txt_jishimz:'技師',
    txt_ltlcgsnew:'輪胎續航里程為{0}km',
    txt_ltlcgsnewin: 'Tire range is {0} miles',
    txt_pinnate_wear: '羽狀磨損',
    txt_msjxtx:'輪胎已達極限，請立即更換',
    txt_ltfz:'內外裝反',
    txt_install_check: '安裝檢查',
    txt_install_ok:'安裝正常',
    LF:'[左前輪]',
    RF:'[右前輪]',
    LB:'[左後輪]',
    RB:'[右後輪]',
    FF:'[前軸]',
    BB:'[後軸]',
    txt_appearance_check:'輪胎存在外傷，請維修確認',
    txt_uneven_center:'輪胎中間磨損异常，建議檢查胎壓',
    txt_uneven_out:'輪胎外側磨損异常，建議檢查四輪定位及胎壓',
    txt_pinnate_check:'輪胎存在羽狀磨損，建議對底盤件進行進一步檢查',
    txt_uneven_inside :'輪胎內側磨損异常，建議檢查四輪定位及胎壓',
    'txt_do_further_check;': '請進一步檢查', 
    txt_uneven_bothside:'輪胎兩邊磨損异常，建議檢查四輪定位及胎壓。',
   
    txt_msyzljgh:'輪胎磨損嚴重，請立即更換。',
    txt_serious_trauma_check:"輪胎存在嚴重外傷，建議更換輪胎",
    txt_appearance_lookup:"請檢查輪胎外觀情况",
    txt_wear_lookup :"請檢查輪胎磨損情况",
    txt_dotscsj:'生產時間：{0}（{1}年第{2}周',
    txt_whqdscsj:'未獲取到生產時間',
    purp_tireservice:'輪胎服務',
    purp_vehicle_inspection:'車輛檢查', 
    txt_chassis_check :'底盤檢查',
    txt_chassis_ok:'底盤檢查良好',
    txt_chassis_oil:'减震器漏油，建議做進一步確認，必要時請更換處理。',
    txt_chassis_aging :'軸頭橡膠老化，建議進行更換處理。',
    txt_trauma_eattyre:'輪胎吃胎',
    txt_uneven_eattyre:'輪胎吃胎，建議進行動平衡，以及對四輪定位，懸掛系統進行檢查',
    txt_appearance_eattyre:'輪胎吃胎，建議進行動平衡，以及對四輪定位，懸掛系統進行檢查',
    txt_chassis_eattyre:'輪胎吃胎，建議對四輪定位，懸掛系統進行檢查',
    txt_uneven_high_eattyre:'輪胎嚴重吃胎，建議更換輪胎，以及對四輪定位，懸掛系統進行檢查',
    txt_appearance_high_eattyre:'輪胎嚴重吃胎，建議進行動平衡，以及對四輪定位，懸掛系統進行檢查',
    txt_chassis_high_eattyre:'輪胎嚴重吃胎，建議對四輪定位，懸掛系統進行檢查',
    txt_chassis_uneven:'輪胎异常偏磨，建議對四輪定位，懸掛系統進行檢查',
    txt_pianmoyichang:'輪胎偏磨异常',


    
    txt_khxm:'客戶姓名',
    txt_khyx:'客戶郵箱',
}
    


// WEBPACK FOOTER //
// ./src/i18n/tw.js